import {Stack} from "@mui/material";


export const KnowledgeBasePage = () => {

  return (
    <Stack direction={"column"} sx={{maxHeight: "calc(100dvh - 64px)", height: "100%", border: 0, flex: 1}}>
      <iframe src={"https://dev.kb.openbrain.io"} style={{flex: 1, border: 0}} />
    </Stack>
  )
}